/*
  Episodes Components Constants
 */
export default {
  'nEpisode': 11
};



// WEBPACK FOOTER //
// ./src/constants/episodesConstants.js